import Swiper from 'swiper/bundle';

export default function toggleSwiperCtaServices(enable, instance) {
    const servicesContainer = document.querySelector('.block-cta-services .posts-services');
    const serviceItems = document.querySelectorAll('.block-cta-services .item');

    if (servicesContainer && serviceItems.length) {
        if (enable) {
            if (!instance.swiperCtaServices) {
                servicesContainer.classList.add('swiper');
                serviceItems.forEach(item => item.classList.add('swiper-slide'));

                instance.swiperCtaServices = new Swiper(".swiper-cta-services", {
                    slidesPerView: 1,
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                        },
                    },
                    navigation: {
                        nextEl: ".block-cta-services .swiper-next",
                        prevEl: ".block-cta-services .swiper-prev",
                    },
                });
            }
        } else {
            if (instance.swiperCtaServices) {
                instance.swiperCtaServices.destroy(true, true);
                instance.swiperCtaServices = null;

                servicesContainer.classList.remove('swiper');
                serviceItems.forEach(item => item.classList.remove('swiper-slide'));

                forceReflow(servicesContainer);
            }
        }
    }
}

function forceReflow(element) {
    element.getBoundingClientRect();
}
